import { getAuthenticatedClient } from "../supabaseClient";
import { fleetDataList } from "./defaultapi";
import { parseCSV } from "../utils/parseCsv";
import { remap_items } from "../utils/remapItems";
import { upsertSiteLocations } from "./siteLocationsApi";

const uploadFile = async (formdata, deleteData = false, setDefault = true) => {
  const supabase = getAuthenticatedClient();
  const file = formdata.get("file");
  const userId = formdata.get("userId");

  if (!file) {
    return { error: "No file uploaded." };
  }

  try {
    let { results } = await parseCSV(file);
    // Remap some of the items
    results = remap_items(results);

    let domicileAddressMap = null;
    const domicileAddressMapRaw = formdata.get("domicileAddressMap");
    if (domicileAddressMapRaw) {
      domicileAddressMap = JSON.parse(String(domicileAddressMapRaw));
    }

    for (const item of results) {
      item.user_id = userId;
      let obj = {};
      Object.keys(item).forEach((key) => {
        if (item[key] === "") {
          if (key === "vehicle_type" || key === "address") {
            item[key] = "";
          } else {
            item[key] = 0;
          }
        }
        if (key.startsWith("ES: ")) {
          obj[key.replace("ES: ", "")] = item[key] === "1" ? true : false;
          delete item[key];
        }
      });
      item.electrification_scenario = obj;
    }

    const jsonData = JSON.stringify(results);
    const jsonObject = JSON.parse(jsonData);

    let obj = jsonObject[0];
    let errors = [];

    fleetDataList.forEach((key) => {
      // Check if the key exists in the object, accounting for potential whitespace/control chars
      const keyExists = Object.keys(obj).some(
        (objKey) =>
          objKey.trim() === key.trim() || objKey.replace(/\r$/, "") === key
      );

      if (
        !keyExists &&
        key !== "equipment_id" &&
        key !== "inflation_start_year"
      ) {
        errors.push(`missing key ${key}`);
      }
    });

    if (errors.length > 0) {
      return { error: errors };
    }

    if (deleteData) {
      const { error: deleteError } = await supabase
        .from("fleet data")
        .delete()
        .eq("user_id", userId)
        .select();
      if (deleteError) {
        return { error: deleteError.message };
      }
    }

    const updatedJsonObject = jsonObject.map((item) => {
      // Create a new object to store the updated item
      const newItem = {
        inflation_start_year: new Date().getFullYear(),
      };

      // Iterate over keyList and add the key to newItem if it exists in item, otherwise add it as null
      fleetDataList.forEach((key) => {
        if (key !== "equipment_id") {
          // Find the matching key in the item, accounting for whitespace/control chars
          const matchingKey = Object.keys(item).find(
            (itemKey) =>
              itemKey.trim() === key.trim() ||
              itemKey.replace(/\r$/, "") === key
          );

          newItem[key] = matchingKey ? item[matchingKey] : null;
        }

        if (key === "inflation_start_year") {
          newItem[key] = item[key] || new Date().getFullYear();
        }
      });
      return newItem;
    });

    const { data, error } = await supabase
      .from("fleet data")
      .insert(updatedJsonObject)
      .select();

    if (error) {
      return { error: error.message };
    }

    if (data?.length === 0) {
      return { error: "Error uploading file" };
    }

    if (domicileAddressMap) {
      const siteResponse = await upsertSiteLocations(userId, domicileAddressMap);
      if (siteResponse.error) {
        return { error: siteResponse.error };
      }
    }

    if (setDefault) {
      const { data: defaultData, error: defaultError } = await supabase
        .from("default data")
        .insert({ id: userId, fleet_data: data });

      if (defaultError) {
        return { error: defaultError.message };
      }
    }

    return { message: "File uploaded successfully!" };
  } catch (error) {
    return { error: error.message || "Error processing CSV file" };
  }
};

export const uploadWithDelete = async (formdata) => {
  return uploadFile(formdata, true, false);
};

export const uploadWithOutDelete = async (formdata) => {
  return uploadFile(formdata, false, true);
};
